export default __webpack_public_path__ + "static/media/expand.41f2c054.svg";